import {
  FilterOption,
  Filter
} from '../../../components/_WMS/FilterComponent/types'
import {
  createBackendTransformer,
  createDisplayTransformer
} from '../../../types/filters'
import { SupplierOriginAutoCompleter } from '../../SupplierOrigin20/components/SupplierOriginAutoCompleter'
import { SupplierAutoCompleter } from '../../Supplier20/components/SupplierAutoCompleter'
import { CreatedDateRangePicker } from '../components/CreatedDateRangePicker'
import { DateTime } from 'luxon'
import { eAsnState } from '../../../enums/eAsnState'

const createdDateRangeBackendTransformer = (rawValue: string): string => {
  try {
    JSON.parse(rawValue)
    return rawValue
  } catch {
    return rawValue
  }
}

// Transformador para display: parsea JSON y formatea las fechas
const createdDateRangeDisplayTransformer = (rawValue: string): string => {
  try {
    const parsed = JSON.parse(rawValue)
    const initialDate = DateTime.fromISO(parsed.initialCreatedDate).toFormat('dd/MM/yyyy')
    const finalDate = DateTime.fromISO(parsed.finalCreatedDate).toFormat('dd/MM/yyyy')
    return `${initialDate} - ${finalDate}`
  } catch {
    return rawValue
  }
}

export const filterOptions: FilterOption[] = [
  {
    key: 'asnId',
    label: 'ID',
    type: 'text',
    order: 1
  },
  {
    key: 'asnNumber',
    label: 'Nro ASN',
    type: 'text',
    order: 2
  },
  {
    key: 'supplierId',
    label: 'Proveedor',
    type: 'custom',
    Component: SupplierAutoCompleter,
    order: 3,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    key: 'supplierOriginId',
    label: 'Origen',
    type: 'custom',
    Component: SupplierOriginAutoCompleter as React.ComponentType<any>,
    order: 5,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    key: 'brandId',
    label: 'Marca',
    type: 'precreated',
    order: 7
  },
  {
    key: 'asnStateId',
    label: 'Estado',
    type: 'precreated',
    order: 8,
    canBeRepeated: true
  },
  {
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated',
    order: 9
  },
  {
    key: 'createdDateRange',
    label: 'Rango Fecha Creación',
    type: 'custom',
    Component: CreatedDateRangePicker,
    order: 10,
    transformForBackend: createdDateRangeBackendTransformer,
    transformForDisplay: createdDateRangeDisplayTransformer
  }
]

export const defaultFilters: Filter[] = [
  {
    key: 'asnStateId',
    value: eAsnState.Pending,
    label: 'Estado',
    displayValue: 'Pendiente'
  },
  {
    key: 'asnStateId',
    value: eAsnState.PreReception,
    label: 'Estado',
    displayValue: 'Pre-Recepción'
  },
  {
    key: 'asnStateId',
    value: eAsnState.Received,
    label: 'Estado',
    displayValue: 'Recepcionada'
  },
  {
    key: 'asnStateId',
    value: eAsnState.ReceptionMassive,
    label: 'Estado',
    displayValue: 'Recepción masiva'
  },
  {
    key: 'asnStateId',
    value: eAsnState.Controlled,
    label: 'Estado',
    displayValue: 'Controlado'
  },
  {
    key: 'asnStateId',
    value: eAsnState.Locating,
    label: 'Estado',
    displayValue: 'Ubicando productos'
  },
  {
    key: 'asnStateId',
    value: eAsnState.PendingResponseES,
    label: 'Estado',
    displayValue: 'Pendiente Respuesta AE'
  }
]
